import { useQuery } from '@hooks/reactQuery';

import { getPortalTasksLinkTypes } from '@api/portalTasks';

import { optionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { PORTAL_TASKS_LINK_TYPES } from '@constants/queryKeys';

interface IUseQueryPortalTasksLinkTypesReturned {
	portalTasksLinkTypes: Array<TSelectOption>;
	isLoadingPortalTasksLinkTypes: boolean;
}

export const useQueryPortalTasksLinkTypes = (): IUseQueryPortalTasksLinkTypesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [PORTAL_TASKS_LINK_TYPES],
		queryFn: getPortalTasksLinkTypes,
		select: requestTypes => optionsFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		portalTasksLinkTypes: data || [],
		isLoadingPortalTasksLinkTypes: isLoading || isFetching,
	};
};
